export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-01.f972ce5c.jpg";